import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const JuchuShubetsu = props => {
  return <Dropdown.Static kubunKey='juchu_shubetsu' {...props} />
}
